<template>
  <div style="max-width: 28rem;">
    <h1 class="h3">{{ $t('view.SignIn.title') }}</h1>
    <ds ds="form"
      id="sign-in"
      @valid="e => isValid = e.detail"
      @submit="submitSignIn"
    >
      <ds ds="input-string"
        name="email"
        :label="$t('shared.label.email')"
        type="email"
        :value="email"
        @dsInput="({ detail }) => (email = typeof detail === 'string' ? detail.toLocaleLowerCase() : detail)"
        :validate="ds.vEmail"
        class="_m:bottom(3)"
      />
      <ds ds="input-string"
        name="password"
        :label="$t('shared.label.password')"
        type="password"
        :value.sync="password"
        :validate="v => ds.vMinLength(8)(v) || ds.vIncludeUppercase(v)|| ds.vIncludeLowercase(v) || ds.vIncludeNumber(v)"
        class="_m:bottom(3)"
      />
      <ds ds="button"
        :label="$t('view.SignIn.action')"
        version="primary"
        :isLoading="isLoading"
        icon="arrow-right"
        type="submit"
      />
      <ds ds="button"
        :label="$t('view.SignUp.forgotPassword')"
        mode="text"
        @click="$router.push({ name: 'forgot-password' })"
        class="_m:top(4)"
        id="forgot-password"
      />
      <ds ds="button"
        :label="$t('view.SignIn.signUpAction')"
        mode="text"
        @click="$router.push({ name: 'sign-up' })"
        class="auth-footer"
      />
    </ds>
  </div>
</template>

<script>
import { eventBus } from '@/eventBus';
import { authHelper } from '@/mixins';
import { authGuard } from '@tokenyico/vuejs-toolkit/src/exports/mixins/guards';
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'SignIn',
  mixins: [authHelper, authGuard({ name: 'appIndex' })],
  data: () => ({
    email: '',
    password: '',
    isLoading: false,
    isValid: false
  }),
  computed: {
    windowTitle () {
      return this.$t('view.SignIn.title');
    },
    ...mapGetters({
      locale: 'locale/locale'
    })
  },
  methods: {
    ...mapActions({
      investorLanguage: 'qualification/investorLanguage'
    }),
    async submitSignIn () {
      eventBus.$emit('isSubmitting', true);
      this.isLoading = true;
      try {
        await this.signIn({ email: this.email, password: this.password });
        await this.investorLanguage(this.locale);
        this.$router.push({ name: 'appIndex' });
      } catch (error) {
        if (error.code === 'UserNotConfirmedException') {
          this.$router.push({ name: 'confirm-sign-up' });
        }
      } finally {
        eventBus.$emit('isSubmitting', false);
        this.isLoading = false;
      }
    }
  },
  async mounted () {
    if (process.env.VUE_APP_AUTH_REDIRECTION_URL) {
      window.location.replace(process.env.VUE_APP_AUTH_REDIRECTION_URL);
    }
  }
};
</script>
